var map = {
	"./circle-group-color.png": "./src/assets/circle-group-color.png",
	"./express-trailers-logo.png": "./src/assets/express-trailers-logo.png",
	"./italiansped-logo.png": "./src/assets/italiansped-logo.png",
	"./logo-cirle-white.png": "./src/assets/logo-cirle-white.png",
	"./logo-italiansped-footer_140x50.png": "./src/assets/logo-italiansped-footer_140x50.png",
	"./logo-italiansped.png": "./src/assets/logo-italiansped.png",
	"./logo-milos-gscv.png": "./src/assets/logo-milos-gscv.png",
	"./logo_circle_invertito.png": "./src/assets/logo_circle_invertito.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";